import React, { useCallback } from 'react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import {
  Messenger,
  Instagram,
} from '@groovehq/internal-design-system/lib/assets/icons'
import { useDrawer } from 'ducks/drawers/hooks'
import StartContent from 'components/StartContent'
import social from 'assets/chat/illustrations/social.png'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import { CHANNEL_MAIN_TYPES } from 'subapps/settings/components/drawers/Channels/Channels.data'

import { styles } from './styles'

const EmptyPage = () => {
  const {
    drawerId: messengerDrawerId,
    openDrawer: openMessengerDrawer,
  } = useDrawer(CHANNEL_MAIN_TYPES.facebook.drawer)
  const {
    drawerId: instagramDrawerId,
    openDrawer: openInstagramDrawer,
  } = useDrawer(CHANNEL_MAIN_TYPES.instagram.drawer)

  const handleCreateOAuthMessenger = useCallback(
    () => {
      openMessengerDrawer('new', {
        query: {
          ...buildDrawerQueryParam(
            messengerDrawerId,
            'drawerChannelType',
            'facebook'
          ),
        },
        additionalProps: {
          firstStep: true,
        },
      })
    },
    [openMessengerDrawer, messengerDrawerId]
  )

  const handleCreateOAuthInstagram = useCallback(
    () => {
      openInstagramDrawer('new', {
        query: {
          ...buildDrawerQueryParam(
            instagramDrawerId,
            'drawerChannelType',
            'instagram'
          ),
        },
        additionalProps: {
          firstStep: true,
        },
      })
    },
    [openInstagramDrawer, instagramDrawerId]
  )

  return (
    <div css={styles.container}>
      <div css={styles.innerContainer}>
        <StartContent
          title="Keep in touch on Social"
          subtitle={`Let your ${app.t(
            'agents'
          )} keep on top of your social support right from your Groove ${app.t(
            'mailbox'
          )}.`}
          css={styles.content}
        >
          <div css={[text.styles.textSm, text.styles.fontSemibold]}>
            Setup time of 2 minutes or less.
          </div>
          <div css={styles.btns}>
            <Button
              css={styles.btn}
              type="tertiary"
              size="xBig"
              onClick={handleCreateOAuthMessenger}
              customIcon={<Messenger />}
            >
              Connect Messenger
            </Button>
            <Button
              type="tertiary"
              size="xBig"
              css={styles.btn}
              onClick={handleCreateOAuthInstagram}
              customIcon={<Instagram />}
            >
              Connect Instagram
            </Button>
          </div>
        </StartContent>
        <div css={styles.imgWrapper}>
          <img src={social} alt="Empty" />
        </div>
      </div>
    </div>
  )
}

export default EmptyPage
